<template>
  <Select :options="fieldOptions" :value="action?.field" @changeValue="changeValue('field', $event)" placeholder="Field" />
  <Select v-if="!isSubAction" :options="collectionOptions" :value="action.collection" @changeValue="changeValue('collection', $event)" placeholder="Collection" />
</template>

<script>
import DefaultPackage from './DefaultPackage.vue'
export default {
  extends: DefaultPackage,
  computed: {
    fieldOptions() {
      return Object.entries(this.packages?.[this.action?.package]?.fields || {}).reduce((result, [key, value]) => {
        result.push({
          id: key,
          text: value.label
        })
        return result
      }, [])
    }
  }
}
</script>
